const initialState = {
    isModalVisible: false,
  };
  
  const removedExpiredAdsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_REMOVED_EXPIRED_ADS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_REMOVED_EXPIRED_ADS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default removedExpiredAdsModalReducer;
  